import { useNavigate, Link } from "react-router-dom";

import { Button } from "../../../components/core/Button";
import { Modal, TModalProps } from "../../../components/others/Modal";

type TModalCheckEmailProps = {
    mail: string
} & TModalProps

export const ModalCheckEmail = ({
    mail,
    urlTittle
}: TModalCheckEmailProps) => {

    const navigate = useNavigate()

    const handleAccept = (e: React.MouseEvent) => {
        navigate("/")
        e.preventDefault();
    }

    return (
        <>
            <Modal
                urlTittle={urlTittle}
                onClose={handleAccept}
                show
            >
                <div className="w-full grid grid-rows-3">
                    <h2 className="font-bold w-full flex justify-center text-xl">¡Listo! Revisa tu correo</h2>
                    <p>
                        <span>Enviamos un correo a</span>
                        <span className="mx-2 font-bold">{mail}</span>
                        <span>para que valides tu usuario.</span>
                    </p>
                    <div className="flex justify-center align-middle">
                        {/* <Button
                        type="button"
                        text="Cancelar"
                        className="bg-white font-bold text-red-500 border-red-500"
                        onClick={() =>{ onClose && onClose() }}
                    /> */}
                        <Button
                            type="button"
                            text="Aceptar"
                            className="bg-red-500 font-bold text-white w-[auto]"
                            onClick={handleAccept}
                        />
                    </div>
                </div>
            </Modal>
        </>)
}